export function getNextId(model: {}) {
  return Math.max(0, ...(Object.keys(model) || [0]).map(id => parseInt(id, 10))) + 1;
}

let lastElementId = 0;

export function newElementId(prefix = 'id-') {
  lastElementId += 1;
  return `${prefix}${lastElementId}`;
}



// WEBPACK FOOTER //
// ./src/utils/ids.js